module.exports = __webpack_public_path__ + "static/1953ec56-f56a-4799-82f6-5557d79d261e-3249fa6c1a121fe97fc4f19c1cfc0d1d.webp";